import { Avatar, Button, Drawer, Layout, List } from 'antd';
import styled from 'styled-components';

const { Header: ANTDHeader } = Layout;

interface StyledHeaderProps {
  $admin: boolean;
}

export const StyledHeader = styled(ANTDHeader)<StyledHeaderProps>`
  background: ${props => props.theme.palette.background.light};
  height: 86px;
  display: flex;
  justify-content: space-between;
  padding: 0 25px;
  align-items: center;
  position: fixed;
  width: ${props => `calc(100% - ${props.$admin ? 208 : 0}px)`};
  box-shadow: 1px 3px 5px 0px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 1px 3px 5px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 1px 3px 5px 0px rgba(0, 0, 0, 0.1);
  z-index: 5;
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer {
    &-content-wrapper {
      height: auto;
    }

    &-header {
      padding: 35px 24px;
      background: ${props => props.theme.palette.background.secondary};
    }

    &-body {
      background: transparent;
      padding: 0;
    }
  }
`;

export const UserAvatar = styled(Avatar)`
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const Name = styled.div`
  margin-left: 8px;
`;

export const Username = styled.div`
  font-size: 12px;
  font-weight: normal;
  line-height: 1.3;
  word-break: break-all;
`;

export const Company = styled.div`
  font-size: 12px;
  font-weight: normal;
  line-height: 1.3;
  color: ${props => props.theme.palette.text.secondary};
`;

export const PageTitle = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  font-size: 22px;
`;

export const StyledListItem = styled(List.Item)`
  border-top: 1px solid ${props => props.theme.palette.border};
  border-bottom: 1px solid ${props => props.theme.palette.border} !important;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 30px;
  cursor: pointer;

  .anticon {
    font-size: 16px;
    margin-right: 20px;
  }
`;

export const BackButton = styled(Button)`
  margin-right: 10px;
  color: ${props => props.theme.palette.text.secondary};
  display: flex;
  align-items: center;
  border: none !important;
  justify-content: center;
  width: 40px;
  height: 40px;

  .anticon {
    font-size: 26px;
    margin-bottom: -3px;
    color: ${props => props.theme.palette.text.secondary} !important;
  }

  &:hover,
  &:active,
  &:focus {
    color: ${props => props.theme.palette.text.secondary};
    outline: none;
  }
`;
